import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  SpeechServiceVoice,
  SpeechServiceRecognition,
  SpeechServiceVoiceControl,
  SpeechServiceAnalytics,
  SpeechServiceNLP,
  SpeechServiceDiarization,
  SpeechServiceBiometrics,
  SpeechServicesSynthesis,
  SpeechServiceAssessment,
} from "../../../app-constants";

function Voiceservices() {
  return (
    <section className="voice_services p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Services We Offer as a Voice Recognition Software Company</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServiceVoice}
                    </div>
                    <div className="voice_service_head">
                      <h5>Voice Self-Service Systems</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Deploy autonomous software to replace customer service
                      agents seamlessly, enhancing efficiency and customer
                      satisfaction through intelligent voice interactions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServiceRecognition}
                    </div>
                    <div className="voice_service_head">
                      <h5>Speech Recognition</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Utilize state-of-the-art technology to accurately convert
                      spoken language into written text, ensuring reliable
                      transcription and data entry.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServiceVoiceControl}
                    </div>
                    <div className="voice_service_head">
                      <h5>Voice Control</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Implement voice-activated controls to operate software and
                      hardware effortlessly with intuitive spoken commands,
                      improving accessibility and user experience.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServiceAnalytics}
                    </div>
                    <div className="voice_service_head">
                      <h5>Speech Analytics</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Leverage advanced speech analytics to extract valuable
                      business insights from employee and customer
                      conversations, driving informed decision-making and
                      performance improvement.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{SpeechServiceNLP}</div>
                    <div className="voice_service_head">
                      <h5>Natural Language Processing (NLP)</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Enable seamless human-like communication with machines,
                      facilitating more natural and effective interactions
                      through sophisticated natural language processing.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServiceDiarization}
                    </div>
                    <div className="voice_service_head">
                      <h5>Speaker Diarization</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Accurately distinguish and separate individual voices in
                      multi-speaker environments, ensuring clarity and precision
                      in audio processing.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServiceBiometrics}
                    </div>
                    <div className="voice_service_head">
                      <h5>Voice Biometrics</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Enhance security with voice biometrics, using unique vocal
                      characteristics as a reliable and unforgettable password
                      for user authentication.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServicesSynthesis}
                    </div>
                    <div className="voice_service_head">
                      <h5>Speech Synthesis</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Incorporate artificial speech generation to provide users
                      with a more inclusive and convenient interaction
                      experience, catering to diverse needs and preferences.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {SpeechServiceAssessment}
                    </div>
                    <div className="voice_service_head">
                      <h5>Speech Assessment</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Conduct comprehensive speech assessments to analyze
                      various aspects of spoken language, offering valuable
                      insights for training, development, and performance
                      evaluation.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Voiceservices;
